/**
 * ====================================================================
 * WeLearn Pro Player: Default configuration
 * Default configurations with comments. Don't edit this file.
 * ====================================================================
 */

const defaults = {

    // This is a mode for preview video. User metadata, Progression data, Slide, Progress bar will be disabled.
    previewMode: false,

    // Set to true if the video is from link.
    embedVideo: false,

    // Credential of user
    user: '',

    // URL of this video
    video: '',

    // URL to thumbnail of the video
    thumbnail: '',

    // Determine if this player can be seek.
    seekable: true,

    // Debug mode. Show debug log in console.
    debug: false,

    // Sync slide with video
    slidesync: false,

    // Determine the URL to be Ajax with when update and load video view progress.
    progress: {

        // Configuration about how video update its progress to the server.
        update: {

            // PHP page URL for update update progress.
            url: 'updateURL.php',

            // Update interval (milliseconds)
            interval: 20000,

            // Display Bootstrap alert when player failed to update progress.
            alert: false,

            // Message that display with alert.
            alertMessage: 'Failed to update user\'s progress. Please refresh to try again or continue'
        },

        load: {

            // PHP page URL for load user progress.
            url: 'retrieveURL.php',

            // Display Bootstrap alert when player failed to get video progress.
            alert: true,

            // Message that display with alert.
            alertMessage: 'ไม่สามารถรับค่าความคืบหน้าของวีดิโอได้ โปรด Refresh เพื่อลองใหม่'
        }
    },

    // Page elements those associate with the plugin
    pageElement: {

        // Modal that display video.
        videoModal: "#modalPreviewXL"
    },

    // Note customization
    note: {

        // Note retrieval
        get: {

            // URL to get note script
            url: "getNote.php"
        },

        // Note saving event
        save: {

            // URL to save note script
            url: "updateNote.php",

            // Display Bootstrap alert when note saved.
            alert: false,

            // Text when note saved successfully
            successMessage: "บันทึกข้อความสำเร็จ",

            // Text when note saved failed
            failureMessage: "บันทึกข้อความไม่สำเร็จ กรุณาลองใหม่อีกครั้ง",

            // Text when use click note area
            instructionMessage: "พิมพ์ข้อความแล้วกดปุ่ม ENTER เพื่อบันทึกข้อความ...",

            // Time until message get removed.
            messageTimeout: 5000
        },

        //Note update event
        update: {

            // URL to update note script
            url: "updateNote.php"
        },

        //Note delete event
        delete: {

            // URL to delete note script
            url: "deleteNote.php"
        }
    },

    // Course batch chat
    chat: {

        // Chat get
        get: {

            // URL to get chat script
            url: "getChat.php"
        }
    },

    // Video quiz
    quiz: {

        // Video quiz will be invoke once unless refresh the page
        invokeOnce: true
    }
};

export default defaults;